export const TARGET_VIEW = 1
export const TARGET_FORM = 2
export const RESIZE_QUALITY = 0.8
export const DEFAULT_WIDTH = 2048
